module.exports = __webpack_public_path__ + "img/front.a2c884ad.png";